import { initGlobalSearch } from './controller.js';

initGlobalSearch();
